import * as tslib_1 from "tslib";
import { HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { navigation } from 'app/navigation/navigation_wsb';
import { configureChatWidget } from '../../../../../../assets/content/js/doppler/chatbot.js';
import { initDopplerNavbar } from '../../../../../../assets/content/js/doppler/navbar-configuration.js';
import { UrlList } from '../url-list.enum';
import { UserRequiredAction } from 'app/constants/user-required-action';
import { checkUserConfiguration } from 'app/shared/util/common-functions';
import { AuthRoles } from '../model/enum/auth-roles.enum';
const DOPPLER_STYLE_ENABLED = environment.DOPPLER_STYLE_ENABLED;
const META_PERMISSION_REQUEST_ENABLED = environment.META_PERMISSION_REQUEST_ENABLED;
const URL_BASE_DOPPLER_CONFIGURATION = environment.URL_BASE_DOPPLER_CONFIGURATION;
const URL_DOPPLER_MAIN = environment.URL_DOPPLER_MAIN;
const DOPPLER_STYLE_GUIDE = environment.DOPPLER_STYLE_GUIDE;
const DOPPLER_SESSION_MFE = environment.DOPPLER_SESSION_MFE;
const DOPPLER_MENU_MFO = environment.DOPPLER_MENU_MFO;
const BEAMER_ID = environment.BEAMER_ID;
export class SessionService {
    constructor(http, loginService, router, _scriptService, document, _roomService, _navigationService, _fuseNavigationService, _localStorageService, navigationRoomStatusService, _snackBar, translate) {
        this.http = http;
        this.loginService = loginService;
        this.router = router;
        this._scriptService = _scriptService;
        this.document = document;
        this._roomService = _roomService;
        this._navigationService = _navigationService;
        this._fuseNavigationService = _fuseNavigationService;
        this._localStorageService = _localStorageService;
        this.navigationRoomStatusService = navigationRoomStatusService;
        this._snackBar = _snackBar;
        this.translate = translate;
        this.url = UrlList.URL;
        this.urlIntegraded = UrlList.URL_PROFILE_INTEGRATED;
    }
    canActivate(route, state) {
        if (this.loginService.isAuthenticated()) {
            return true;
        }
        else {
            this.router.navigate(['/pages/auth/login']);
            return false;
        }
    }
    getUserProfile(login, isExternal) {
        return this.http
            .get(this.urlIntegraded + UrlList.GET_USER_PROFILE + '/' + login)
            .pipe(concatMap(data => {
            data['login'] = login; // set field "login"
            data['isExternal'] = isExternal;
            return this.identity(data);
        }), catchError(err => throwError(err)));
    }
    createUser(user) {
        const userProfile = this._localStorageService.getCurrentUser();
        const body = {
            login: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phoneNumber: user.phone,
            customerId: userProfile.customerId,
            pwd: user.password,
            authorities: [user.role],
            emailSignature: `<p><strong>${user.lastName} ${user.firstName}</p></strong>`,
        };
        return this.http.post(this.urlIntegraded + UrlList.CREATE_USER, body);
    }
    deleteUser(user) {
        const body = {
            id: user.id,
            login: user.login,
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phoneNumber,
            email: user.email,
            status: user.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
            customerId: user.customersId,
            authorities: user.authorities,
            emailSignature: user.emailSignature,
            appStatus: user.appStatus === null ||
                user.appStatus === 'ENABLED' ||
                user.appStatus === 'CHANGED' ||
                user.appStatus === 'DATACHANGED'
                ? 'DISABLED'
                : 'ENABLED',
            receiveNotification: user.receiveNotification === null || user.receiveNotification === false
                ? true
                : false,
            providerUserId: user.providerUserId,
        };
        return this.http.post(this.urlIntegraded + UrlList.DELETE_USER, body);
    }
    updateUser(user) {
        this.getUser(user.id).subscribe(u => {
            user.deviceKey = u.deviceKey;
            this.sendLogoutNotification(user);
        });
        const body = {
            id: user.id,
            login: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phone,
            email: user.email,
            status: user.status,
            customerId: user.customersId,
            authorities: [user.role],
            emailSignature: user.emailSignature,
            appStatus: user.appStatus === 'DISABLED' ? 'DISABLED' : 'DATACHANGED',
            receiveNotification: user.receiveNotification === null || user.receiveNotification === false
                ? true
                : false,
            providerUserId: user.providerUserId,
        };
        return this.http.post(this.urlIntegraded + UrlList.DELETE_USER, body);
    }
    validateEmail(email) {
        let headers = new HttpHeaders();
        headers = headers.append('Skip-Authorization', 'true');
        const body = {
            email: email,
        };
        return this.http.post(UrlList.URL_SECURITY + UrlList.VALIDATE_EMAIL, body, {
            headers,
        });
    }
    sendLogoutNotification(user) {
        const body = {
            notification: {
                title: '',
                body: '',
            },
            priority: 'high',
            to: user.deviceKey,
        };
        const headers = new HttpHeaders({
            Authorization: 'KEY=AAAAVsAtWVk:APA91bH6ymNXN1RBGHMBg_CAuOZAZ6MzSVV4sdkCbPNahM2NNkSWldZFQNRu6fyETxhhkNsqdmpeRFrpRvTCf-qZ3-_TvLOnoZQioERhf9EF4mz6K-wpDX_oVq4xdUTpF7YK3JTMpFcR',
        });
        const options = {
            headers: headers,
        };
        return this.http.post('https://fcm.googleapis.com/fcm/send', body, options);
    }
    getUser(id) {
        return this.http.get(UrlList.URL_PROFILE_INTEGRATED + UrlList.MOBILE_GET_PROFILE + id);
    }
    setUserData(data) {
        const userLoginSession = {
            id: data.id,
            login: data.login,
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            cellphone: data.phoneNumber,
            authorities: data.authorities,
            customerId: data.customerId,
            uaaUserId: data.uaaUserId,
            customerUserPreferences: data.customerUserPreferences,
            langKey: data.langKey,
            emailSignature: null,
            isExternal: data.isExternal,
            path: '',
            admEmail: data.admEmail,
            assignedRooms: data.assignedRooms,
            providerUserId: data.providerUserId,
            requiredAction: data.requiredAction,
            customerConfigurations: data.customerConfigurations,
            frontConfigurations: data.frontConfigurations,
            plan: data.plan,
        };
        // Set current Rol
        const currentRol = data.authorities[0];
        if (data.emailSignature !== null) {
            userLoginSession.emailSignature = data.emailSignature;
        }
        else {
            userLoginSession.emailSignature = `<p><strong>${data.lastName} ${data.firstName}</p></strong>`;
        }
        // Check if the user has to change the password
        const profilePath = '/pages/profile';
        const isUpdatePwd = userLoginSession.requiredAction &&
            userLoginSession.requiredAction === UserRequiredAction.UPDATE_PASSWORD;
        if (userLoginSession && currentRol === 'ROLE_ADMIN') {
            // Default redirection for user with ADMIN role
            userLoginSession.path = isUpdatePwd
                ? profilePath
                : '/apps/dashboards/analytics';
        }
        else if (userLoginSession && currentRol === 'ROLE_ATC') {
            userLoginSession.path = isUpdatePwd ? profilePath : '/apps/dashboards/project';
        }
        // TODO: solo para solicitar permisos de whatsapp
        if (META_PERMISSION_REQUEST_ENABLED) {
            userLoginSession.path = '/apps/rooms';
        }
        // Save user data to localstorage
        this._localStorageService.setCurrentUser(userLoginSession);
        return userLoginSession;
    }
    getAuthorities() {
        const userProfile = this._localStorageService.getCurrentUser();
        const configValues = userProfile.frontConfigurations &&
            userProfile.frontConfigurations.configurations
            ? userProfile.frontConfigurations.configurations
            : [];
        return this.http.post(UrlList.URL_SECURITY + UrlList.USER_AUTHORITIES, configValues);
    }
    getRoomsByCustomerPromise(data) {
        return new Promise((resolve, reject) => {
            this._roomService.getRoomsByCustomer(data).subscribe(resp => resolve(resp), err => reject(err));
        });
    }
    /**
     * Get menu list in Beplic
     * @param data {login} : logged in username. ex: test@gmail.com
     * @returns json with menu list
     * @see  MS Partners-> NavigationResource.class
     */
    getNavigationPromise(data) {
        return new Promise((resolve, reject) => {
            return this.http
                .get(UrlList.URL_PARTNER + '/api/menu/' + data.login)
                .pipe(map((navigationMenu) => this.filterNavigationMenuByConfig(navigationMenu)))
                .subscribe((navigationMenu) => {
                resolve(navigationMenu);
            }, err => reject(err));
        });
    }
    identity(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const currentUser = this.setUserData(data);
                // Init navigation menu construction asynchronously
                this.initMainConfiguration(Object.assign({}, currentUser, { isDopplerMenuLoaded: currentUser.isExternal }));
                return currentUser;
            }
            catch (error) {
                throw error;
            }
        });
    }
    initMainConfiguration(userProfile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.loginService.setLoggedIn(true); // Set Logged in user to true
                // Init doppler setup
                this.initDopplerConfiguration(userProfile);
                let navigationMenu = null;
                // TODO: solo para solicitar permisos de Meta
                if (META_PERMISSION_REQUEST_ENABLED) {
                    navigationMenu = JSON.parse(JSON.stringify(navigation));
                }
                else {
                    navigationMenu = yield this.getNavigationPromise({
                        login: userProfile.email,
                    });
                }
                // Init Current Navigation without rooms
                this._navigationService.initCurrentNavigation(navigationMenu, []);
                // Get rooms assigned to the user asynchronously
                this.getRoomsByCustomerPromise({
                    customersId: userProfile.customerId,
                    customeruserId: userProfile.id,
                })
                    .then((customerUserRooms) => {
                    this.checkRooms(customerUserRooms, userProfile);
                    // Init Current Navigation with rooms
                    this._navigationService.buildNavigationMenu(navigationMenu, customerUserRooms);
                    // Set assigned rooms in session storage
                    this.setRoomsByCustomers(customerUserRooms);
                    // Actualiza el contador general
                    this.navigationRoomStatusService.updateGeneralCounter();
                    // Starting reactive services
                    this._fuseNavigationService.getReactiveProfile();
                })
                    .catch(err => {
                    console.warn('Could not get rooms to show in the navigation menu');
                });
            }
            catch (error) {
                console.error('Could not start navigation menu. {}', error);
            }
        });
    }
    checkRooms(customerUserRooms, userProfile) {
        const authorities = userProfile.authorities
            ? userProfile.authorities
            : [];
        if (customerUserRooms.length === 0 && authorities.includes(AuthRoles.ROLE_ATC)) {
            this.openSnackBar();
        }
    }
    openSnackBar() {
        this._snackBar.open(this.translate.instant('NAV.EMPTY.REQUEST_FOR_ROOM'), this.translate.instant('TEMPLATE.SNACKBAR.CLOSE'), {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['custom-snackbar-info'],
        });
    }
    initDopplerConfiguration(userProfile) {
        if (userProfile && userProfile.frontConfigurations.partner === 2) {
            // Activate Doppler navigation menu if the user logged in from Doppler
            if (userProfile.isExternal && !userProfile.isDopplerMenuLoaded) {
                // Init Doppler navigation menu
                this.initDopplerNavigationMenu(userProfile.authorities[0]);
            }
            // Set Doppler Styles Theme
            this.document.body.classList.add('theme-doppler');
            // Show chatbot only for the Doppler partner
            const scriptDoopler = this._scriptService.loadScriptWithPromise(this._scriptService.getDataDopplerChatbot());
            scriptDoopler
                .then(() => {
                configureChatWidget();
            })
                .catch(() => { });
        }
        // Activate Doppler styles for debugging
        if (DOPPLER_STYLE_ENABLED) {
            this.document.body.classList.add('theme-doppler');
        }
    }
    initDopplerNavigationMenu(currentRol) {
        // Init navigation menu settings
        const config = {
            dopplerLegacyBaseUrl: URL_BASE_DOPPLER_CONFIGURATION,
            redirectTo: `${URL_DOPPLER_MAIN}/login`,
            enableRedirection: currentRol === 'ROLE_ADMIN',
            dopplerStyleGuide: DOPPLER_STYLE_GUIDE,
            dopplerSessionMfe: DOPPLER_SESSION_MFE,
            dopplerMenuMfe: DOPPLER_MENU_MFO,
            beamerId: BEAMER_ID,
            endSessionFn: () => {
                this.loginService.logout();
            },
        };
        // Setup for doppler navigation menu
        initDopplerNavbar(config);
    }
    setRoomsByCustomers(rooms) {
        if (JSON.parse(sessionStorage.getItem('myRooms'))) {
            sessionStorage.removeItem('myRooms');
        }
        const roomsToSave = rooms || [];
        sessionStorage.setItem('myRooms', JSON.stringify(roomsToSave));
    }
    filterNavigationMenuByConfig(navigationMenu) {
        return navigationMenu
            .map((navigationItem) => {
            // It is traversed recursively if it has children.
            if (navigationItem.children) {
                navigationItem.children = this.filterNavigationMenuByConfig(navigationItem.children);
            }
            // If the menu option has the configuration associated with the user, it is displayed
            if (!navigationItem.feature ||
                checkUserConfiguration([navigationItem.feature])) {
                return navigationItem;
            }
            return null;
        })
            .filter((navigationItem) => {
            // Filter: remove null objects and those without children
            return (navigationItem !== null &&
                (navigationItem.children === undefined ||
                    navigationItem.children === null ||
                    navigationItem.children.length > 0));
        }); // remove null elements
    }
}
